//local server
// export const VUE_WEB_BASEURL = "http://127.0.0.1:8000/";
// export const VUE_APP_BASEURL = "http://127.0.0.1:8000/api/v1/";

//live server
export const VUE_APP_BASEURL = "https://admin.sivakasicrackersz.in/api/v1/";
export const VUE_WEB_BASEURL = "https://admin.sivakasicrackersz.in/";
